import React, { forwardRef, useEffect, useRef, useState, useImperativeHandle } from 'react';
import debounce from './debounce';
import { XCricle } from '../../assets/images';

type searchBarProps = {
  search: (data: string) => void;
  initialValue?: string;
};

interface refProps {
  setSearch: (search: string) => void;
}

const Searchbar = forwardRef<refProps, searchBarProps>(({ search, initialValue }, ref) => {
  //  const Searchbar: React.FunctionComponent<searchBarProps> = ({ search , initialValue }): JSX.Element => {
  const [value, setvalue] = useState(initialValue || '');
  const callBack = useRef(true);
  const SearchValue = debounce(value, 500);

  useEffect(() => {
    if (search !== undefined && callBack.current) {
      search(value);
    }
  }, [SearchValue]);

  const setSearch = (search: string) => {
    callBack.current = false;
    setvalue(search);
  };

  useImperativeHandle(ref, () => ({
    setSearch,
  }));

  return (
    <div className="flex h-full w-full rounded-full bg-white">
      <input
        type="text"
        className="h-full w-5/6 rounded-l-full text-center focus:ring-transparent"
        value={value}
        onChange={(e) => {
          callBack.current = true;
          setvalue(e.target.value);
        }}
        placeholder="SEARCH"
        data-testid="search-input"
      />
      <div
        className="flex h-full w-1/6 items-center justify-center rounded-r-full pr-2"
        onClick={() => {
          setvalue('');
          search('');
        }}
        data-testid="search-clear-button"
      >
        {value.length > 0 && <img src={XCricle} alt="closeButton"></img>}
      </div>
    </div>
  );
});

Searchbar.displayName = 'Searchbar';

export default Searchbar;
